module.exports = __webpack_public_path__ + "img/1515250235.c6f42be2.jpg";